<!-- Loading bar -->
<spri-loading-bar />

<div class="patient-form-layout-root relative flex min-h-screen w-full flex-col bg-white">
  <div class="flex flex-1 min-[1366px]:min-w-[1366px]">
    <section class="flex min-h-screen min-w-0 flex-1 flex-col items-start pb-3">
      <div class="flex w-full max-w-[520px] flex-1 flex-col px-[30px] pt-12">
        <header class="mb-8 flex shrink-0 items-center">
          <img alt="Tenant logo" class="h-12 w-auto max-w-[240px] object-contain" [src]="logoUrl()" />
        </header>

        <div class="mb-4 flex flex-col gap-6">
          <router-outlet />
        </div>
      </div>

      <p class="mx-[30px] mt-auto w-[calc(100%-60px)] shrink-0 border-t border-[#d1d5db] py-3 text-xs text-gray-500">
        {{ footerTitle() }} {{ tenantContextService.currentYear }}
      </p>
    </section>

    <aside
      aria-hidden="true"
      class="relative hidden min-w-0 flex-1 self-start bg-gradient-to-r from-gray-100 to-gray-200 bg-cover bg-center bg-no-repeat p-[30px] md:sticky md:top-0 md:block md:h-screen"
      [style.backgroundImage]="rightImageUrl() ? 'url(' + rightImageUrl() + ') !important' : null"
    >
      @if (footerLogos().length) {
        <div
          class="absolute bottom-[30px] left-[30px] right-[30px] flex items-center justify-evenly gap-6 rounded bg-white px-[30px] py-4"
        >
          @for (logo of footerLogos(); track logo.src) {
            <img class="w-auto max-w-[190px] object-contain" [alt]="logo.alt" [src]="logo.src" />
          }
        </div>
      }
    </aside>
  </div>

  @if (showManualFormLink()) {
    <div class="pointer-events-none absolute inset-0 overflow-hidden [&>*]:pointer-events-auto">
      <button
        aria-label="Open manual form"
        class="absolute bottom-6 right-6 h-10 w-10 opacity-0"
        (click)="onManualFormClick()"
      ></button>

      <!-- Close button outside drawer so it isn't clipped by .spri-drawer-content (overflow: hidden) -->
      @if (manualOffcanvasOpen) {
        <button
          aria-label="Close manual form"
          class="fixed right-[502px] top-4 z-[301] flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-0 bg-gray-200 text-gray-700 shadow transition-colors hover:bg-gray-300"
          type="button"
          (click)="closeManualFormOffcanvas(); $event.stopPropagation()"
        >
          <mat-icon aria-hidden="true" class="sidebar-icon" svgIcon="sidebar" />
        </button>
      }

      <spri-drawer
        class="manual-form-drawer"
        mode="over"
        position="right"
        [fixed]="true"
        [opened]="manualOffcanvasOpen"
        (openedChanged)="manualOffcanvasOpen = $event"
      >
        <spri-manual-form-content />
      </spri-drawer>
    </div>
  }
</div>
